import { createActions } from "redux-actions";

const action = createActions({
  ADMIN: {
    CLEAN_REPORT: undefined,
    API: {
      CLEAN_REPORT: undefined
    }
  }
})

const configuration = {
  name: 'cleanReport',
  action: action,
  sagas: undefined,
  reducers: {
    reducer: (state, action) => ({
      ...state,
      report: undefined,
      userStat: undefined,
      businessReport: undefined,
      businessActivities: undefined,
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/cleanReport.js